import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { contentLibraryFilePreviewRequested } from 'features/content-library/actions';

export function* requestPreviewContentLibraryFileSaga(
  action: ReturnType<typeof contentLibraryFilePreviewRequested>
) {
  const { id, personal = false } = action.payload;

  yield call(SignalingSocket.send, {
    event: 'openLibraryFile',
    data: {
      id,
      personal,
      preview: true,
    },
  });
}
